import {
  MESSAGING_TOPIC_ADD_REQUEST,
  MESSAGING_TOPIC_ADD_SUCCESS,
  MESSAGING_TOPIC_ADD_FAILURE,
  // MESSAGING_TOPIC_DIRTY,
  // MESSAGING_TOPIC_CLEAN,
  RESET_MESSAGING_STATE,
  RESET_TOPIC_STATE,
  MESSAGING_GROUP_CHAT_PRE_SIGN_URL_FOR_UPLOAD_REQUEST,
  MESSAGING_GROUP_CHAT_PRE_SIGN_URL_FOR_UPLOAD_SUCCESS,
  MESSAGING_GROUP_CHAT_PRE_SIGN_URL_FOR_UPLOAD_FAILURE,
  MESSAGING_GROUP_CHAT_UPLOAD_FILE_REQUEST,
  MESSAGING_GROUP_CHAT_UPLOAD_FILE_FAILURE,
  MESSAGING_GROUP_CHAT_UPLOAD_FILE_SUCCESS,
  MESSAGING_GROUP_CHAT_ADD_REQUEST,
  MESSAGING_GROUP_CHAT_ADD_FAILURE,
  MESSAGING_GROUP_CHAT_ADD_SUCCESS,
  MESSAGING_DIRECT_CHAT_PRE_SIGN_URL_FOR_UPLOAD_REQUEST,
  MESSAGING_DIRECT_CHAT_PRE_SIGN_URL_FOR_UPLOAD_SUCCESS,
  MESSAGING_DIRECT_CHAT_PRE_SIGN_URL_FOR_UPLOAD_FAILURE,
  MESSAGING_DIRECT_CHAT_UPLOAD_FILE_REQUEST,
  MESSAGING_DIRECT_CHAT_UPLOAD_FILE_SUCCESS,
  MESSAGING_DIRECT_CHAT_UPLOAD_FILE_FAILURE,
  MESSAGING_DIRECT_CHAT_ADD_REQUEST,
  MESSAGING_DIRECT_CHAT_ADD_SUCCESS,
  MESSAGING_DIRECT_CHAT_ADD_FAILURE,
  MESSAGING_DIRECT_CHAT_OPEN,
  SET_CURRENT_TOPIC_ID,
  SET_CURRENT_MESSAGE_ID,
  MESSAGING_BROADCAST_ADD_REQUEST,
  MESSAGING_BROADCAST_ADD_SUCCESS,
  MESSAGING_BROADCAST_ADD_FAILURE,
  MESSAGING_SET_NAV_MODE,
  TOPICS_GET_BY_USER_REQUEST,
  TOPICS_GET_BY_USER_SUCCESS,
  TOPICS_GET_BY_USER_FAILURE,
  MESSAGING_BROADCAST_TAPPED,
} from '../../actions/actionTypes';

const INITIAL_STATE = {
  errorMessage: '',
  status: 'no',
  fetchAllStatus: 'no',
  // stateDirty: false,
  statusImage: 'no',
  signedImageName: null,
  signedUploadUrl: null,
  currentMessageId: null,
  navMode: 'patient',
  brodcastTapCounter: 0,
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case TOPICS_GET_BY_USER_REQUEST:
      return { ...state, fetchAllStatus: 'requesting' };
    case TOPICS_GET_BY_USER_SUCCESS:
      return { ...state, fetchAllStatus: 'success' };
    case TOPICS_GET_BY_USER_FAILURE:
      return { ...state, fetchAllStatus: 'failed' };

    case MESSAGING_SET_NAV_MODE:
      return { ...state, navMode: action.payload };
    case MESSAGING_TOPIC_ADD_REQUEST:
    case MESSAGING_BROADCAST_ADD_REQUEST:
      return { ...state, status: 'requesting', errorMessage: '' };
    case MESSAGING_TOPIC_ADD_SUCCESS:
    case MESSAGING_BROADCAST_ADD_SUCCESS:
      return { ...state, status: 'success', errorMessage: '' };
    case MESSAGING_TOPIC_ADD_FAILURE:
    case MESSAGING_BROADCAST_ADD_FAILURE:
      return { ...state, status: 'failed', errorMessage: action.payload };

    // case MESSAGING_TOPIC_DIRTY:
    //   return { ...state, stateDirty: true };
    // case MESSAGING_TOPIC_CLEAN:
    //   return { ...state, stateDirty: false };

    //TODO: If we use a generic component to upload images we can move all this reducer code to a separate reducer
    case MESSAGING_GROUP_CHAT_PRE_SIGN_URL_FOR_UPLOAD_REQUEST:
    case MESSAGING_DIRECT_CHAT_PRE_SIGN_URL_FOR_UPLOAD_REQUEST:
      return { ...state, statusImage: 'presigning', errorMessage: '' };
    case MESSAGING_GROUP_CHAT_PRE_SIGN_URL_FOR_UPLOAD_SUCCESS:
    case MESSAGING_DIRECT_CHAT_PRE_SIGN_URL_FOR_UPLOAD_SUCCESS:
      return {
        ...state,
        statusImage: 'signed',
        signedImageName: action.payload.data.fileName,
        signedUploadUrl: action.payload.data.url,
      };
    case MESSAGING_GROUP_CHAT_PRE_SIGN_URL_FOR_UPLOAD_FAILURE:
    case MESSAGING_DIRECT_CHAT_PRE_SIGN_URL_FOR_UPLOAD_FAILURE:
      return { ...state, statusImage: 'failure', errorMessage: action.payload };
    case MESSAGING_GROUP_CHAT_UPLOAD_FILE_REQUEST:
    case MESSAGING_DIRECT_CHAT_UPLOAD_FILE_REQUEST:
      return { ...state, statusImage: 'uploading', errorMessage: '' };
    case MESSAGING_GROUP_CHAT_UPLOAD_FILE_SUCCESS:
    case MESSAGING_DIRECT_CHAT_UPLOAD_FILE_SUCCESS:
      return { ...state, statusImage: 'success' };
    case MESSAGING_GROUP_CHAT_UPLOAD_FILE_FAILURE:
    case MESSAGING_DIRECT_CHAT_UPLOAD_FILE_FAILURE:
      return { ...state, statusImage: 'failure', errorMessage: action.payload };
    case MESSAGING_GROUP_CHAT_ADD_REQUEST:
    case MESSAGING_DIRECT_CHAT_ADD_REQUEST:
      return { ...state, status: 'requesting', errorMessage: '' };
    case MESSAGING_GROUP_CHAT_ADD_SUCCESS:
    case MESSAGING_DIRECT_CHAT_ADD_SUCCESS:
      return {
        ...state,
        status: 'success',
        errorMessage: '',
        signedImageName: null,
        signedUploadUrl: null,
      };
    case MESSAGING_GROUP_CHAT_ADD_FAILURE:
    case MESSAGING_DIRECT_CHAT_ADD_FAILURE:
      return {
        ...state,
        status: 'failed',
        errorMessage: action.payload,
        signedImageName: null,
        signedUploadUrl: null,
      };
    case SET_CURRENT_TOPIC_ID:
    case MESSAGING_DIRECT_CHAT_OPEN:
      return {
        ...state,
        currentMessageId: action.payload.currentMessageId || null,
      };
    case SET_CURRENT_MESSAGE_ID:
      return {
        ...state,
        currentMessageId: action.payload,
      };
    case MESSAGING_BROADCAST_TAPPED:
      return {
        ...state,
        brodcastTapCounter: state.brodcastTapCounter + 1,
      };
    case RESET_TOPIC_STATE:
      return {
        ...state,
        errorMessage: '',
        status: 'no',
        // stateDirty: false,
      };
    case RESET_MESSAGING_STATE:
      return Object.assign({}, INITIAL_STATE);
    default:
      return state;
  }
}
